import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VideoService {
videolink$ = new BehaviorSubject(null);
constructor() { }

}
